/* eslint-disable import/prefer-default-export */

export const RELOAD_REQUESTED = 'RELOAD_REQUESTED';
export const PUSH_NOTIFICATION_CHANGED = 'PUSH_NOTIFICATION_CHANGED';
export const IS_SUBMITTING_CHANGED = 'IS_SUBMITTING_CHANGED';
export const ESTIMATED_NUMBER_OF_SENDS_CHANGED = 'ESTIMATED_NUMBER_OF_SENDS_CHANGED';
